<template>
  <div class="menu-list">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <b-card
            header-tag="header"
            footer-tag="footer">
            <div slot="header">
              <i className="fa fa-align-justify"></i><strong class="text-uppercase">{{ $t('store.outlets') }}</strong>
              <div class="pull-right mr-4">
                <button type="button" class="btn btn-success right" @click="createOutlets"><i class="fa fa-plus"></i>&nbsp; {{$t('store.new')}}</button>
              </div>
            </div>
            <b-col cols="12">
              <b-row>
                <b-col cols="6">
                  <div>
                    <button type="button" class="btn btn-success" @click="exportCSV">
                      {{$t('common.export_csv')}}
                    </button>
                    <button type="button" class="btn btn-success" @click="exportCSVMenuExclusions" v-if="outlet_config.config 
                      && outlet_config.config.show_menu_exclusion === true 
                      && (typeof outlet_config.config.show_menu_control === 'undefined' || outlet_config.config.show_menu_control !== false) 
                      && (checkPermission($auth.user(), 'get.v1.product-menu-be.menu-control-export') || checkPermission($auth.user(), permissions.EXPORT_OOS_GROUP_BY_STORE))">
                      {{$t('store.export_menu_exclusion')}}
                    </button>
                    <button type="button" class="btn btn-success" @click="exportCSVMenuOutOfStock" v-if="outlet_config.config 
                      && !outlet_config.config.show_menu_exclusion && outlet_config.config.show_menu_out_of_stock === true 
                      && (typeof outlet_config.config.show_menu_control === 'undefined' || outlet_config.config.show_menu_control !== false) 
                      && (checkPermission($auth.user(), 'get.v1.product-menu-be.menu-control-export') || checkPermission($auth.user(), permissions.EXPORT_OOS_GROUP_BY_STORE))">
                      {{$t('store.export_menu_out_of_stock')}}
                    </button>
                    <button type="button" class="btn btn-success" @click="exportCSVTemplate" v-if="outlet_config.config
                      && outlet_config.config.show_menu_exclusion === true 
                      && (typeof outlet_config.config.show_menu_control === 'undefined' || outlet_config.config.show_menu_control !== false) 
                      && checkPermission($auth.user(), 'get.v1.product-menu-be.menu-control-export')">
                      {{$t('store.export_template_menu_exclusion')}}
                    </button>
                    <button type="button" class="btn btn-success" @click="exportLiveDeal" v-if="hasDealLive">
                      {{ $t('store.csv_export_deal_live') }}
                    </button>
                  </div>
                  <div class="d-flex mt-2" v-if="outlet_config.config && outlet_config.config.show_menu_exclusion">
                    <div class="mr-1"
                     v-if="outlet_config.config && (typeof outlet_config.config.show_menu_control === 'undefined' || outlet_config.config.show_menu_control !== false) && checkPermission($auth.user(), 'get.v1.product-menu-be.menu-control-export')">
                      <ImportFile action="block-menu" :submit-text="$t('common.block_menu')" @importFile="blockMenuWithCsv"/>
                    </div>
                    <div class="mr-1"
                      v-if="outlet_config.config && (typeof outlet_config.config.show_menu_control === 'undefined' || outlet_config.config.show_menu_control !== false) && checkPermission($auth.user(), 'get.v1.product-menu-be.menu-control-export')">
                      <ImportFile action="unblock-menu" :submit-text="$t('common.unblock_menu')"
                                  @importFile="unblockMenuWithCsv"/>
                    </div>
                    <div class="mr-1"
                      v-if="outlet_config.config && (typeof outlet_config.config.show_menu_control === 'undefined' || outlet_config.config.show_menu_control !== false) && checkPermission($auth.user(), 'get.v1.product-menu-be.menu-control-export')">
                      <ImportFile action="crust-size-control" :submit-text="$t('common.control_crust_size')"
                                  @importFile="handleCrustAndSizeWithCsv"/>
                    </div>
                  </div>
                </b-col>
                <b-col cols="6" class="d-flex">
                  <div class="mr-4">
                    <b-input-group v-bind:prepend="$t('store.active')">
                      <b-form-select v-model="filter.status" v-bind:value="filter.status" :options="statuses[$session.get('lang')]" v-bind:placeholder="$t('store.active')">
                      </b-form-select>
                    </b-input-group>
                  </div>
                  <div class="flex-grow-1">
                    <b-input-group>
                      <select-dropdown v-bind:options="filter.options" v-bind:selected="filter.selected" position="prepend" v-bind:all="false" v-model="filter.field" prefix="store">
                      </select-dropdown>
                      <input type="text" class="form-control" v-model="filter.key" v-on:keydown.enter="refreshData"/>
                      <div class="input-group-append">
                        <b-input-group-append>
                          <b-btn @click="refreshData()"><i class="fa fa-search" ></i> {{$t('common.search')}}</b-btn>
                        </b-input-group-append>
                      </div>
                    </b-input-group>
                  </div>
                </b-col>
              </b-row>

              <div class="table-responsive outlet-data text-center">
                <table class="table table-striped table-hover table-sm table-bordered">
                  <thead>
                  <tr>
                    <th scope="col" v-show="!checkPermission($auth.user(),'hide-active')">{{$t('store.active')}}</th>
                    <th scope="col" :class="item.sort?'pointer':''" v-for="item in dataTable.fields" :key="item.id" @click="updateSort(item.name)">
                      <i class="fa fa-sort-amount-asc text-muted" v-if="dataTable.sort.type == 'asc' && dataTable.sort.field == item.name"></i>
                      <i class="fa fa-sort-amount-desc text-muted" v-if="dataTable.sort.type == 'desc' && dataTable.sort.field == item.name"></i>
                      <span v-if="item.label != null">{{$t('store.'+item.label)}}</span>
                      <span v-if="item.label == null">{{$t('store.'+item.name)}}</span>
                    </th>
                    <th scope="col" style="min-width: 175px">{{$t('common.action')}}</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-if="dataTable.items.length == 0">
                    <td class="text-center" :colspan="dataTable.fields.length + 2">
                      {{$t('message.no_data')}}
                    </td>
                  </tr>
                  <tr v-for="item in dataTable.items" :key="item.id">
                    <td scope="row" v-show="!checkPermission($auth.user(),'hide-active')">
                      <c-switch-custom type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d' , disabled: updateOutletStatus}" :pill="true" v-model="item.active" :value="1" :uncheckedValue="0" @change="showConfirmStatusItem(item)"/>
                    </td>
                    <td scope="row" class="text-left" v-for="field in dataTable.fields" :key="field.id">
                      <span v-if="field.render != null" v-html="field.render(item[field.name == 'outlet_collection' ? 'quote_time' : field.name == 'outlet_delivery' ? 'quote_time' : field.name], item)"></span>
                      <span v-if="field.render == null">
                        {{item[field.name]}}
                      </span>
                    </td>
                    <td scope="row">
                      <b-button size="sm" variant="primary" v-on:click="editItem(item.uuid)">
                        <i class="fa fa-edit"></i> {{$t('common.edit')}}
                      </b-button>

                      <b-button size="sm" variant="secondary" v-show="!checkPermission($auth.user(),'hide-menu-control')" v-on:click="editMenuControl(item.uuid)" v-if="outlet_config.config && (typeof outlet_config.config.show_menu_control === 'undefined' || outlet_config.config.show_menu_control !== false)">
                        <i class="fa fa-gears"></i> {{$t('store.menu_control')}}
                      </b-button>

                      <b-button size="sm" variant="secondary" v-on:click="showPrintCode(item.code, item.name)" v-if="outlet_config.config && typeof outlet_config.config.print_qr !== 'undefined' && outlet_config.config.print_qr !== false">
                        <i class="fa fa-print"></i> {{$t('client.print_qr')}}
                      </b-button>

                      <b-button size="sm" variant="secondary" v-on:click="editControlDeals(item.uuid, item.name)" v-if="isUK">
                        <i class="fa fa-edit"></i> {{$t('store.deals')}}
                      </b-button>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <b-row>
                <b-col>
                  <b-pagination :total-rows="dataTable.total" :per-page="dataTable.perPage" v-model="dataTable.currentPage" />
                </b-col>
                <b-col class="text-left">
                  {{$t('message.datatable_total', {number: dataTable.items.length, total: dataTable.total})}}
                </b-col>
                <b-col col lg="1">
                  <b-form-select v-model="dataTable.perPage" :options="[10, 20, 50, 100]" class="mb-3"/>
                </b-col>
              </b-row>
            </b-col>
          </b-card>
        </b-col>
      </b-row>
    </div>

<!--    show QR code-->
    <b-modal ref="QR" id="qr_modal" hide-header class="modal-dialog">
      <div class="qr-code-img" id="qr_image">
        <qrcode-vue v-if="valueQR" :value="valueQR" size="450" level="H" id="qr_code"></qrcode-vue>
        <div class="qr-code-text">
          <span>{{qr_outletCode}} - {{qr_outletName}}</span>
        </div>
      </div>
      <template v-slot:modal-footer="{ Download }">
        <b-button size="sm" variant="success" @click="printCanvas">
          Download
        </b-button>
      </template>
    </b-modal>

  </div>
</template>
<script>
import SelectDropdown from '../../../components/Partials/SelectDropdown'
import DataTable from '../../../components/Partials/DataTable'
import DateRangePicker from 'vue2-daterange-picker'
import axios from 'axios'
import cSwitch from '../../../components/Switch'
import cSwitchCustom from '../../../components/SwitchCustom'

import { ExportToCsv } from 'export-to-csv'
import html2canvas from 'html2canvas'
import QrcodeVue from 'qrcode.vue'
import ImportFile from '../../../components/ImportFile'
import ExportOOS from '../../../utils/oos/ExportOOS'
import { EXPORT_OOS_GROUP_BY_STORE } from '../../../utils/constants/Permissions'

const CancelToken = axios.CancelToken
let cancel = null
let vm = null
let dispositions = {
  'D': 'common.delivery',
  'C': 'common.takeaway',
  'R': 'common.restaurant'
}
const UK_LIMIT_NUMBER = 1000
const ORG_ADMIN = 'org-admin'
const SUPER_ADMIN_ID = 1

export default {
  name: 'OutletList',
  components: {
    ImportFile,
    SelectDropdown,
    DateRangePicker,
    cSwitch,
    DataTable,
    QrcodeVue,
    cSwitchCustom
  },
  data: function () {
    return {
      outletConfig: this.$store.getters.config.gms.outlet,
      updateOutletStatus : true,
      csvOptions: {
        fieldSeparator: ',',
        filename: this.$t('store.store_list'),
        quoteStrings: '"',
        decimalSeparator: '.',
        showLabels: true,
        showTitle: false,
        useTextFile: false,
        useBom: true,
        useKeysAsHeaders: false,
        headers: [
          this.$t('store.code'),
          this.$t('store.name'),
          this.$t('store.area_code'),
          this.$t('store.jpchar'),
          this.$t('store.owner_code'),
          this.$t('store.owner_name'),
          this.$t('store.address'),
          this.$t('store.phone'),
          this.$t('common.delivery'),
          this.$t('common.takeaway'),
          this.$t('store.min_cart_D'),
          this.$t('store.min_cart_C'),
          this.$t('store.lat'),
          this.$t('store.long'),
          // this.$t('common.january'),
          // this.$t('common.january'),
          // this.$t('common.february'),
          // this.$t('common.february'),
          // this.$t('common.march'),
          // this.$t('common.march'),
          // this.$t('common.april'),
          // this.$t('common.april'),
          // this.$t('common.may'),
          // this.$t('common.may'),
          // this.$t('common.june'),
          // this.$t('common.june'),
          // this.$t('common.july'),
          // this.$t('common.july'),
          // this.$t('common.august'),
          // this.$t('common.august'),
          // this.$t('common.september'),
          // this.$t('common.september'),
          // this.$t('common.october'),
          // this.$t('common.october'),
          // this.$t('common.november'),
          // this.$t('common.november'),
          // this.$t('common.december'),
          // this.$t('common.december'),
          this.$t('store.outlet_collection'),
          this.$t('store.outlet_delivery'),
          this.$t('store.delivery_fee')]
      },
      csvMenuExclusionsOptions: {
        fieldSeparator: ',',
        filename: this.$t('store.menu_exclusion'),
        quoteStrings: '"',
        decimalSeparator: '.',
        showLabels: true,
        showTitle: false,
        useTextFile: false,
        useBom: true,
        useKeysAsHeaders: false,
        headers: [
          this.$t('store.outlet_code'),
          this.$t('store.outlet_name'),
          this.$t('store.menu_code'),
          this.$t('store.menu_name'),
          this.$t('store.disposition')
        ]
      },
      csvTemplateMenuExclusionsOptions: {
        fieldSeparator: ',',
        filename: this.$t('store.export_template_menu_exclusion'),
        quoteStrings: '"',
        decimalSeparator: '.',
        showLabels: true,
        showTitle: false,
        useTextFile: false,
        useBom: true,
        useKeysAsHeaders: false,
        headers: [
          this.$t('csv.menu_sku'),
          this.$t('csv.outlet_code'),
          this.$t('csv.is_combo')
        ]
      },
      csvMenuOOSExclusionsOptions: {
        fieldSeparator: ',',
        filename: this.$t('store.menu_exclusion'),
        quoteStrings: '"',
        decimalSeparator: '.',
        showLabels: true,
        showTitle: false,
        useTextFile: false,
        useBom: true,
        useKeysAsHeaders: false,
        headers: [
          this.$t('store.type'),
          this.$t('store.name').toLowerCase(),
          this.$t('store.cluster'),
          this.$t('store.hutid')
        ]
      },
      csvLiveDealOptions: {
        fieldSeparator: ';',
        filename: this.$t('store.csv_dl_filename'),
        quoteStrings: '"',
        decimalSeparator: '.',
        showLabels: true,
        showTitle: false,
        useTextFile: false,
        useBom: true,
        useKeysAsHeaders: false,
        headers: [
          this.$t('store.csv_dl_header_store_code'),
          this.$t('store.csv_dl_header_store_name'),
          this.$t('store.csv_dl_header_store_sku'),
          this.$t('store.csv_dl_header_store_deal_name')
        ]
      },
      userInfo: null,
      outlet_config: {},
      payment_method: [],
      type: 'like',
      startDate: this.$moment().subtract(7, 'days').format('YYYY-MM-DD'),
      endDate: this.$moment().format('YYYY-MM-DD'),
      statuses: [],
      OutletsListCode: [],
      permissions: { EXPORT_OOS_GROUP_BY_STORE },
      filter: {
        options: [],
        selected: null,
        startDate: this.$moment().subtract(7, 'days').format('YYYY-MM-DD'),
        endDate: this.$moment().format('YYYY-MM-DD'),
        status: 1,
        code: '',
        field: null,
        key: null
      },
      dataTable: {
        items: [],
        fields: [
          {
            name: 'code',
            filter: true,
            sort: true,
            render: (data, row) => {
              if (data == null) {
                return ''
              }
              return data
            }
          },
          {
            name: 'name',
            filter: true,
            sort: true,
            render: (data, row) => {
              if (data == null) {
                return ''
              }
              return data[this.$session.get('lang')]
            }
          },
          {
            name: 'area_code',
            filter: true,
            sort: false,
            render: (data, row) => {
              if (data == null) {
                return ''
              }
              return data
            }
          },
          {
            name: 'jpchar',
            filter: true,
            sort: false,
            render: (data, row) => {
              if (data == null) {
                return ''
              }
              return data
            }
          },
          {
            name: 'owner_code',
            filter: true,
            sort: false,
            render: (data, row) => {
              if (data == null) {
                return ''
              }
              return data
            }
          },
          {
            name: 'owner_name',
            filter: true,
            sort: false,
            render: (data, row) => {
              if (data == null) {
                return ''
              }
              return data
            }
          },
          {
            name: 'address',
            filter: true,
            sort: true,
            render: (data, row) => {
              if (data == null) {
                return ''
              }
              return data[this.$session.get('lang')]
            }
          },
          {
            name: 'outlet_collection',
            filter: false,
            sort: false,
            render: (data, row) => {
              if (data == null || !data.hasOwnProperty('C')) {
                return ''
              }
              let text = data.C
              let division = row.division.C
              let disposition = row.disposition
              if (text <= 0 || division == 2) {
                text = this.$t('store.cannot_accept_order')
              }
              if(!disposition.some((item) => item == 'C')) {
                text = this.$t('store.out_of_service')
              }
              return text
            }
          },
          {
            name: 'outlet_delivery',
            filter: false,
            sort: false,
            render: (data, row) => {
              if (data == null || !data.hasOwnProperty('D')) {
                return ''
              }
              let text = data.D
              let division = row.division.D
              let disposition = row.disposition
              if (text <= 0 || division == 2) {
                text = this.$t('store.cannot_accept_order')
              }
              if(!disposition.some((item) => item == 'D')) {
                text = this.$t('store.out_of_service')
              }
              return text
            }
          },{
            name: 'customize',
            label: "No of Driver",
            filter: false,
            sort: false,
            render: (data, row) => {
              if (data == null || !data.hasOwnProperty('no_of_driver')) {
                return ''
              }
              let text = data.no_of_driver
              return text
            }
          },
          {
            name: 'disposition',
            filter: false,
            sort: false,
            render: (data, row) => {
              let html = []
              for (let i in dispositions) {
                let exist = '<i class="fa fa-times text-danger"></i>'
                if (data.indexOf(i) >= 0) {
                  exist = '<i class="fa fa-check text-success"></i>'
                }
                html.push(this.$t(dispositions[i]) + ': ' + exist)
              }
              return html.join('<br/>')
            }
          }
        ],
        sort: {
          field: 'updated_at',
          type: 'desc'
        },
        currentPage: 1,
        total: 0,
        perPage: 20,
        source: null
      },
      item: {},
      valueQR: '',
      qr_outletCode: '',
      qr_outletName: '',
      outletCodeObject: {}
    }
  },
  computed: {
    hasDealLive: function() {
      return this.isUK && (this.userInfo.id === SUPER_ADMIN_ID || this.userInfo.roles.includes(ORG_ADMIN) || this.userInfo.stores.length > 0)
    },
    isUK: function () {
      return localStorage.getItem('clientID') === vm.client_uuid.uk1 || localStorage.getItem('clientID') === vm.client_uuid.uk2
    },
  },
  methods: {
    checkFilter() {
      let data = null
      try {
        const cache = localStorage.getItem('outletFilter')
        data = JSON.parse(cache)
        localStorage.removeItem('outletFilter')
      } catch (error) {
        console.error(`Error checkFilter ${error}`)
      }
      this.filter.selected = data && data.field || null
      this.filter.code = data && data.code || ''
      this.filter.status = !data ? 1 : (data && data.status || data.status)
      this.filter.field = data && data.field || ''
      this.filter.key = data && data.key || null
      this.filter.startDate = data && data.startDate || this.$moment().format('YYYY-MM-DD')
      this.filter.endDate = data && data.endDate || this.$moment().format('YYYY-MM-DD')
    },
    saveCacheFilter() {
      localStorage.setItem('outletFilter', JSON.stringify(this.filter))
    },
    checkPermission(userInfo, permission){
      let modules = userInfo.modules ? userInfo.modules : {}
      let adminIds = [1, 34, 35, 62]
      return adminIds.indexOf(userInfo.user_id) !== -1 || modules.indexOf(permission) !== -1;
    },
    printCanvas: function () {
      let vm = this

      html2canvas(document.getElementById('qr_image'), {
        scrollX: 0,
        scrollY: 0
      }).then(function (canvas) {
        var imageData = canvas.toDataURL('image/png')
        var element = document.createElement('a')
        element.setAttribute('href', imageData)
        element.setAttribute('download', 'QR_store_' + vm.qr_outletCode)
        element.style.display = 'none'
        document.body.appendChild(element)
        element.click()
        document.body.removeChild(element)
      })
    },
    showPrintCode: function (outletCode, name) {
      this.qr_outletCode = outletCode
      this.qr_outletName = name[vm.$session.get('lang')]
      let prefixUrl = this.$store.getters.config.manual_config.prefix_url ? this.$store.getters.config.manual_config.prefix_url : ''
      let baseSiteUrl = this.$store.getters.config.main.base_site_url + prefixUrl + '?store_code=' + outletCode
      this.valueQR = baseSiteUrl
      this.$refs.QR.show()
    },
    updateDateRange: function (val) {
      this.startDate = this.$moment(val.startDate).format('YYYY-MM-DD')
      this.endDate = this.$moment(val.endDate).format('YYYY-MM-DD')
      this.refreshData()
    },
    updateSort: function (field) {
      for (let i in this.dataTable.fields) {
        if (this.dataTable.fields[i].name == field && (this.dataTable.fields[i].sort == null || this.dataTable.fields[i].sort == false)) {
          return
        }
      }
      if (this.dataTable.sort.field != field) {
        this.dataTable.sort = {
          field: field,
          type: 'asc'
        }
      } else {
        if (this.dataTable.sort.type == 'asc') {
          this.dataTable.sort = {
            field: field,
            type: 'desc'
          }
        } else {
          this.dataTable.sort = {
            field: field,
            type: 'asc'
          }
        }
      }

      this.refreshData()
    },
    getPaymentMethods () {
        vm.axios.payment.getPaymentSimpleList(
          function (response) {
            vm.payment_method = response.data.data.items
          },
          function (error) {
            //your code
          })
      },
    fetchUserInfo () {
      const auth = this.$auth.user()
      return auth.user_info.user
    },

    exportLiveDeal() {
      this.$bus.$emit('loading', 'block')
      const config = vm.$session.get('config');
      const lang = vm.$session.get('lang');
      const manualConfig = vm._.get(config, 'manual_config', {}) || {};
      const {
        tenant_code: tenant = null,
        campaign_name: campaignName = null,
        locale,
        export_path: exportPath = null,
      } = manualConfig;
      const headers = {
        tenant,
        campaignName,
        locale,
        lang,
        exportPath
      };

      const userStoreCodes = this.userInfo.stores
      const convertedUserStoreCodes = userStoreCodes.join() || true
      this.axios.menuOutOfStock.exportDealLive(
        `storeCodes=${convertedUserStoreCodes}`,
        headers,
        (response) => {
          const data = response.data.data.items
          if (data.length <= 0) {
            this.$bus.$emit('loading', 'none')
            this.$toastr.error(this.$t('store.csv_dl_empty_data'), '', {})
            return
          }

          const items = data.map(item => {
            const dealLive = {
              storeCode: item.storeCode,
              storeName: this.outletCodeObject[item.storeCode] || '',
              sku: item.inventoryItem.skus[0].code,
              dealName: item.inventoryItem.title
            }
            return dealLive
          })

          const sortedByCodeItems = items.sort((a, b) => a.storeCode - b.storeCode)
          let csvExporter = new ExportToCsv(vm.csvLiveDealOptions)
          csvExporter.generateCsv(sortedByCodeItems)
          this.$bus.$emit('loading', 'none')
        }, (_) => {
          this.$bus.$emit('loading', 'none')
        })
    },
    exportCSV () {
      let vm = this;
      const payments = [];
      const clientId = vm.$store.getters.config.base && vm.$store.getters.config.base.id ? vm.$store.getters.config.base.id : null
      if (cancel != null) {
        cancel()
      }
      let search = ''
      if (!this._.isEmpty(this.field) && !this._.isEmpty(this.key)) {
        search = '&' + this.field + '=' + this.key.trim()
      }
      if (this.filter.status != '') {
        search = search + '&active=' + this.filter.status
      }

      let params = '?limit=99999999&page=' + this.dataTable.currentPage + '&sort_by=' + this.dataTable.sort.field + '&order_by=' + this.dataTable.sort.type + search
      if(clientId === 2) {
        vm.csvOptions.headers.push('No of Driver')
      }
      vm.csvOptions.headers.push(this.$t('store.alcohol_drinks_available'))
      if(vm.outlet_config.config.support_export_full_csv){
        params += '&export=1';
        //Appen Payments
        if(vm.payment_method.length > 0){
          const paymentAvailableList = vm.payment_method;
          paymentAvailableList.sort((x, y) => x.code.localeCompare(y.code));
          const paymentHeadersCSV = [];
          for(const paymentEntry of paymentAvailableList){
            const paymentDisplayName = paymentEntry.display_name ? paymentEntry.display_name.replace(/,/g, '/') : '';
            paymentHeadersCSV.push(paymentDisplayName)
            payments[paymentEntry.code] = 0
          }
           Array.prototype.push.apply(vm.csvOptions.headers, paymentHeadersCSV);
        }

        // Append Open Hours Header
        Array.prototype.push.apply(vm.csvOptions.headers, [
              this.$t('store.DeliverOpeningMonday'),
              this.$t('store.DeliverClosingMonday'),
              this.$t('store.DeliverOpeningTuesday'),
              this.$t('store.DeliverClosingTuesday'),
              this.$t('store.DeliverOpeningWednesday'),
              this.$t('store.DeliverClosingWednesday'),
              this.$t('store.DeliverOpeningThursday'),
              this.$t('store.DeliverClosingThursday'),
              this.$t('store.DeliverOpeningFriday'),
              this.$t('store.DeliverClosingFriday'),
              this.$t('store.DeliverOpeningSaturday'),
              this.$t('store.DeliverClosingSaturday'),
              this.$t('store.DeliverOpeningSunday'),
              this.$t('store.DeliverClosingSunday'),
              this.$t('store.CarryoutOpeningMonday'),
              this.$t('store.CarryoutClosingMonday'),
              this.$t('store.CarryoutOpeningTuesday'),
              this.$t('store.CarryoutClosingTuesday'),
              this.$t('store.CarryoutOpeningWednesday'),
              this.$t('store.CarryoutClosingWednesday'),
              this.$t('store.CarryoutOpeningThursday'),
              this.$t('store.CarryoutClosingThursday'),
              this.$t('store.CarryoutOpeningFriday'),
              this.$t('store.CarryoutClosingFriday'),
              this.$t('store.CarryoutOpeningSaturday'),
              this.$t('store.CarryoutClosingSaturday'),
              this.$t('store.CarryoutOpeningSunday'),
              this.$t('store.CarryoutClosingSunday')
        ]);

      }

      this.axios.outlet.getOutletList(params, {
        cancelToken: new CancelToken(function executor (c) {
          cancel = c
        })
      },
      function (response) {
        try {
            let dataResponse = response.data.data.items
            let csvData = []

            let defaultNoOfDriver = null
            if(clientId === 2 && vm.$store.getters.config.gms.outlet && vm.$store.getters.config.gms.outlet.fields && vm._.isArray(vm.$store.getters.config.gms.outlet.fields)) {
              vm.$store.getters.config.gms.outlet.fields.map(field => {
                if(field.title === 'no_of_driver' && field.body && vm._.isArray(field.body)) {
                  field.body.map(e => {
                    if(e.name === 'no_of_driver' && e.options && e.options.default) {
                      defaultNoOfDriver = e.options.default
                    }
                  })
                }
              })
            }

            for (let i in dataResponse) {
              let _delivery = 0
              let _carryout = 0
              let _minCart_D = 0
              let _minCart_C = 0
              let minCart = dataResponse[i].min_cart

              if (minCart && minCart.hasOwnProperty('D')) {
                _minCart_D = minCart['D']
                
              }
              if (minCart && minCart.hasOwnProperty('C')) {
                _minCart_C = minCart['C']
              }
              if (dataResponse[i].disposition.length > 0) {
                if (dataResponse[i].disposition.indexOf('D') >= 0) {
                  _delivery = 1
                }
                if (dataResponse[i].disposition.indexOf('C') >= 0) {
                  _carryout = 1
                }
              }
              let _item = {
                code: dataResponse[i].code,
                name: dataResponse[i].name ? dataResponse[i].name[vm.$session.get('lang')] : '',
                area_code: dataResponse[i].area_code || '',
                jpchar: dataResponse[i].jpchar || '',
                owner_code: dataResponse[i].owner_code || '',
                owner_name: dataResponse[i].owner_name || '',
                address: dataResponse[i].address ? dataResponse[i].address[vm.$session.get('lang')] : '',
                phone: dataResponse[i].phone,
                delivery: _delivery + '',
                carryout: _carryout + '',
                min_cart_D: _minCart_D + '',
                min_cart_C: _minCart_C + '',
                lat: dataResponse[i].lat + '',
                long: dataResponse[i].long + '',
                outlet_collection: dataResponse[i].quote_time && dataResponse[i].quote_time.C ? dataResponse[i].quote_time.C + '' : '',
                outlet_delivery: dataResponse[i].quote_time && dataResponse[i].quote_time.D ? dataResponse[i].quote_time.D + '' : '',
                delivery_fee: dataResponse[i].delivery_fee
              }
              // No of Driver
              if(clientId === 2) {
                let customize = typeof(dataResponse[i].customize) === 'object' ? dataResponse[i].customize : null
                _item.no_of_driver = customize && customize.no_of_driver ? customize.no_of_driver : defaultNoOfDriver || ''
              }

              if(vm.outlet_config.config.support_export_full_csv){
                const storePaymentAccepted = dataResponse[i].payment_accepted
                const availablePayment = [];
                // Append Payment data
                if(typeof storePaymentAccepted === 'object') {
                  for(const paymentName in storePaymentAccepted){
                    availablePayment[paymentName] = (storePaymentAccepted[paymentName]['active'] != undefined) ? storePaymentAccepted[paymentName]['active'] : 0
                    payments[paymentName] = availablePayment[paymentName];
                  }
                }

                _item.alcohol_drinks_available = dataResponse[i].alcohol_drinks_available ? dataResponse[i].alcohol_drinks_available : '';

                // Append Open Hours Data
                _item = {
                  ..._item,
                  ...payments,
                  DeliverOpeningMonday: dataResponse[i].DeliverOpeningMonday,
                  DeliverClosingMonday: dataResponse[i].DeliverClosingMonday,
                  DeliverOpeningTuesday: dataResponse[i].DeliverOpeningTuesday,
                  DeliverClosingTuesday: dataResponse[i].DeliverClosingTuesday,
                  DeliverOpeningWednesday:dataResponse[i].DeliverOpeningWednesday,
                  DeliverClosingWednesday: dataResponse[i].DeliverClosingWednesday,
                  DeliverOpeningThursday: dataResponse[i].DeliverOpeningThursday,
                  DeliverClosingThursday: dataResponse[i].DeliverClosingThursday,
                  DeliverOpeningFriday: dataResponse[i].DeliverOpeningFriday,
                  DeliverClosingFriday:dataResponse[i].DeliverClosingFriday,
                  DeliverOpeningSaturday: dataResponse[i].DeliverOpeningSaturday,
                  DeliverClosingSaturday:dataResponse[i].DeliverClosingSaturday,
                  DeliverOpeningSunday:dataResponse[i].DeliverOpeningSunday,
                  DeliverClosingSunday: dataResponse[i].DeliverClosingSunday,
                  CarryoutOpeningMonday: dataResponse[i].CarryoutOpeningMonday,
                  CarryoutClosingMonday: dataResponse[i].CarryoutClosingMonday,
                  CarryoutOpeningTuesday: dataResponse[i].CarryoutOpeningTuesday,
                  CarryoutClosingTuesday: dataResponse[i].CarryoutClosingTuesday,
                  CarryoutOpeningWednesday: dataResponse[i].CarryoutOpeningWednesday,
                  CarryoutClosingWednesday: dataResponse[i].CarryoutClosingWednesday,
                  CarryoutOpeningThursday: dataResponse[i].CarryoutOpeningThursday,
                  CarryoutClosingThursday: dataResponse[i].CarryoutClosingThursday,
                  CarryoutOpeningFriday: dataResponse[i].CarryoutOpeningFriday,
                  CarryoutClosingFriday: dataResponse[i].CarryoutClosingFriday,
                  CarryoutOpeningSaturday: dataResponse[i].CarryoutOpeningSaturday,
                  CarryoutClosingSaturday: dataResponse[i].CarryoutClosingSaturday,
                  CarryoutOpeningSunday: dataResponse[i].CarryoutOpeningSunday,
                  CarryoutClosingSunday: dataResponse[i].CarryoutClosingSunday,
                }
              }

              csvData.push(_item)
            }
            vm.csvOptions.filename = vm.$t('store.store_list')
            let csvExporter = new ExportToCsv(vm.csvOptions)
            csvExporter.generateCsv(csvData)
          } catch (error) {
            console.log('Export Outlet Error: ', error)
          }

        vm.csvOptions.filename = vm.$t('store.store_list')
        let csvExporter = new ExportToCsv(vm.csvOptions)
        csvExporter.generateCsv(csvData)
      },
      function (error) {
        // your code
      })
    },
    exportCSVMenuExclusions () {
      if (localStorage.getItem('clientID') !== vm.client_uuid.uk1 && localStorage.getItem('clientID') !== vm.client_uuid.uk2) {
        if (cancel != null) {
          cancel()
        }
        this.axios.menu.getMenuExclusions(null, {
            cancelToken: new CancelToken(function executor (c) {
              cancel = c
            })
          },
          function (response) {
            if (response.data.data.items.length <= 0) {
              vm.$toastr.error(vm.$t('message.export_menu_exclusion_no_data'), vm.$t('message.success'), {})
            } else {
              let dataResponse = response.data.data.items.map(item => {
                item.disposition = item.disposition ? item.disposition.join('|') : ''
                return item
              })
              vm.csvMenuExclusionsOptions.filename = vm.$t('store.menu_exclusion')
              let csvExporter = new ExportToCsv(vm.csvMenuExclusionsOptions)
              csvExporter.generateCsv(response.data.data.items)
            }
          },
          function (error) {
            // your code
          })
      } else {
        const config = vm.$session.get('config');
        const lang = vm.$session.get('lang');
        const manualConfig = vm._.get(config, 'manual_config', {}) || {};
        const {
          tenant_code: tenant = null,
          campaign_name: campaignName = null,
          locale,
          export_path: exportPath = null,
          available_product_types = null,
          unavailable_product_skus = ''
        } = manualConfig;
        const header = {
          tenant,
          campaignName,
          locale,
          lang,
          exportPath
        };
        const params = available_product_types ? `productTypes=${available_product_types}` : null;
        const unavailableProductSkus = (unavailable_product_skus || '').split(',');
        vm.$toastr.info(vm.$t('message.export_all_oos_message'), vm.$t('message.success'), {})
        vm.axios.menuOutOfStock.exportMenuOutOfStockGroupByStore(params, header,
          response => {
            const  { stores, inventoryItems, pricesItems } = vm._.get(response,'data.data.item', { stores:[], inventoryItems: [], pricesItems: [] });
            if (!vm._.isArray(stores) || stores.length === 0) {
              vm.$toastr.error(vm.$t('message.export_menu_exclusion_no_data'), vm.$t('message.success'), {})
            } else {
              const csvExporter = new ExportToCsv(vm.csvMenuOOSExclusionsOptions)
              const exportOOS = new ExportOOS(stores, pricesItems, inventoryItems, unavailableProductSkus)
              const items = [];

              stores.forEach(store => {
                const oosItems = exportOOS.getOutOfStockTitles(store)
                items.push(...oosItems)
              })

              csvExporter.generateCsv(items.sort((a, b) => {
                if (!vm._.isEmpty(a.hutid) && !vm._.isEmpty(b.hutid)) {
                  return +a.hutid - +b.hutid;
                }
                return 0;
              }))
            }
          }
        );
      }
    },
    exportCSVMenuOutOfStock () {
      const vm = this
      this.axios.menu.exportOutOfStock(function (response) {
        const url = window.URL.createObjectURL(new Blob([response.data], { type: 'text/csv' }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'menu_out_of_stock.csv');
        document.body.appendChild(link);
        link.click();
      })
    },
    exportCSVTemplate () {
      vm.csvMenuExclusionsOptions.filename = vm.$t('store.export_template_menu_exclusion')
      let csvExporter = new ExportToCsv(vm.csvTemplateMenuExclusionsOptions)
      csvExporter.generateCsv([
        {
          menu_sku: 'menu_sku_test',
          outlet_code: 'outlet_code_test',
          is_combo: 0
        },
        {
          menu_sku: 'combo_sku_test',
          outlet_code: 'outlet_code_test',
          is_combo: 1
        }
      ])
    },
    /**
     * Refesh data
    */
    refreshData: function () {
      if (cancel != null) {
        cancel()
      }
      let search = ''
      if (!this._.isEmpty(this.filter.field) && !this._.isEmpty(this.filter.key)) {
        search = '&' + this.filter.field + '=' + this.filter.key.trim()
      }

      if (this.filter.status != '') {
        search = search + '&active=' + this.filter.status
      }

      let limitNumber = vm.dataTable.perPage
      if (vm.isUK) {
        limitNumber = UK_LIMIT_NUMBER
      }

      let params = `?limit=${limitNumber}` + '&page=' + this.dataTable.currentPage + '&sort_by=' + this.dataTable.sort.field + '&order_by=' + this.dataTable.sort.type + search

      this.axios.outlet.getOutletList(params, {
        cancelToken: new CancelToken(function executor (c) {
          cancel = c
        })
      },
      function (response) {
        let langs = Object.keys(vm.$i18n.messages)
        for (let l in langs) {
          vm.statuses[langs[l]] = [
            {text: vm.$t('common.all', langs[l]), value: ''},
            {text: vm.$t('common.active', langs[l]), value: '1'},
            {text: vm.$t('common.inactive', langs[l]), value: '0'}
          ]
          const data = response.data.data.items
          vm.dataTable.items = [...data]
          vm.dataTable.total = response.data.data.pagination.total

          if (vm.isUK) {
            vm.outletCodeObject = [...data].reduce((acc, cur) => {
              acc[cur.owner_code || cur.code] = cur.owner_name || cur.name.en
              return acc
            }, {})

            if (vm.dataTable.items.length > vm.dataTable.perPage) {
              vm.dataTable.items.length = vm.dataTable.perPage
            }
          }
        }
      },
      function (error) {
        // your code
      })
    },

    /**
     * Link for edit outlet
    */

    editItem: function (id) {
      this.saveCacheFilter()
      this.$router.push({name: 'outlets_edit', params: { uuid: id }})
    },

    /**
      * Disable outlet
      * @Params : uuid,status
      * @Method : put
     */
    updateStatusItem: function (item) {
      this.axios.outlet.updateStatusOutlet(item.uuid, {active: item.active}, function (response) {
        vm.$toastr.success(vm.$t('message.update_successful'), vm.$t('message.success'), {})
      }, (err) => {
        vm.refreshData()
      })
    },
    showConfirmStatusItem: function (item) {
      if (localStorage.getItem('clientID') === vm.client_uuid.jp) {
        if (item.active === 0) {
          let options = {
            html: true,
            okText: vm.$t('common.ok'),
            cancelText: vm.$t('common.cancel')
          }
          vm.$dialog.confirm(vm.$t('message_turn_off_store'), options)
          .then(function (dialog) {
            vm.updateStatusItem(item)
          }).catch(function () {
            vm.refreshData()
          })
        } else {
          vm.updateStatusItem(item)
        }
      } else {
        vm.updateStatusItem(item)
      }
      
    },
    /**
      * Create outlet
      */
    createOutlets: function () {
      this.$router.push({name: 'outlets_create'})
    },
    /**
    * Edit Menu Control
    */
    editMenuControl: function (uuid) {
      /** UK DECO  */
      if (localStorage.getItem('clientID') === vm.client_uuid.uk1 || localStorage.getItem('clientID') === vm.client_uuid.uk2) {
        this.$router.push({name: 'menu_out_of_stock', params: { uuid: uuid }})
      } else {
        this.$router.push({name: this.outletConfig.config.show_menu_exclusion === true ? 'menu_control' : 'outlet_out_of_stock', params: { uuid: uuid }})
      }
    },
    blockMenuWithCsv (file, action) {
      if (!file) {
        return
      }

      let formData = new FormData()
      formData.append('block_csv', file)
      formData.append('action', action)
      const config = {headers: {'Content-Type': 'multipart/form-data'}}

      vm.axios.menu.blockMenuWithCsv(formData, config, function (response) {
        vm.$toastr.success(vm.$t('message.update_successful'), vm.$t('message.success'), {})
      })
    },
    unblockMenuWithCsv (file, action) {
      if (!file) {
        return
      }

      let formData = new FormData()
      formData.append('block_csv', file)
      formData.append('action', action)
      const config = {headers: {'Content-Type': 'multipart/form-data'}}

      vm.axios.menu.unblockMenuWithCsv(formData, config, function (response) {
        vm.$toastr.success(vm.$t('message.update_successful'), vm.$t('message.success'), {})
      })
    },
    handleCrustAndSizeWithCsv (file, action) {
      if (!file) {
        return
      }

      let formData = new FormData()
      formData.append('control_file', file)
      formData.append('action', action)
      const config = {headers: {'Content-Type': 'multipart/form-data'}}

      vm.axios.menu.handleCrustAndSizeWithCsv(formData, config, function (response) {
        vm.$toastr.success(vm.$t('message.update_successful'), vm.$t('message.success'), {})
      })
    },
    editControlDeals: function (uuid) {
      if (vm.isUK) {
        this.$router.push({name: 'list_of_all_available_deals', params: { uuid: uuid }})
      }
    },
  },
  created: function () {
    this.userInfo = this.fetchUserInfo()
    let userInfo = this.$auth.user()
    let modules = userInfo.modules
    if (typeof modules !== 'undefined') {
      if (modules.indexOf('put.v1.product-hut-be.outlets.update-status.?') !== -1) {
        this.updateOutletStatus = false
      }
    }
    this.outlet_config = this.$store.getters.config.gms.outlet
    this.debouncedInput = _.debounce(this.refreshData, 240)
    vm = this
    if(vm.outlet_config.config.support_export_full_csv){
      this.getPaymentMethods()
    }
    let CancelToken = vm.axios.CancelToken
    this.dataTable.source = CancelToken.source()
    let dataFields = []
    for (let i in this.dataTable.fields) {
      if (this.dataTable.fields[i].name != 'address' && this.dataTable.fields[i].name != 'customize') {
        dataFields.push(this.dataTable.fields[i])
      } else {
        let client_id = localStorage.getItem('clientID');
        if (client_id == '2f28344b-2d60-4754-8985-5c23864a3737' && this.dataTable.fields[i].name == 'customize') {
          dataFields.push(this.dataTable.fields[i])
        }
        if (this.dataTable.fields[i].name == 'address' && this.outlet_config.config && this.outlet_config.config.show_address_on_list !== false) {
          dataFields.push(this.dataTable.fields[i])
        }
      }
    }

    this.dataTable.fields = dataFields
    for (let i in this.dataTable.fields) {
      if (this.dataTable.fields[i].filter != null && this.dataTable.fields[i].filter == true) {
        this.filter.options.push(this.dataTable.fields[i])
      }
      if (this.dataTable.fields[i].sort != null && this.dataTable.fields[i].sort == true && this.dataTable.sort.field == null) {
        this.dataTable.sort = {
          field: this.dataTable.fields[i].name,
          type: 'asc'
        }
      }
    }

    let filter = this.$session.get('filter', null)
    if (filter != null && this.$route.query && this.$route.query.rollback) {
      for (let i in filter.filter) {
        this.filter[i] = filter.filter[i]
      }
      for (let i in filter.dataTable) {
        this.dataTable[i] = filter.dataTable[i]
      }
    }
    vm.checkFilter()
    vm.refreshData()
  },
  beforeDestroy: function () {
    this.$session.set('filter', {
      filter: this.filter,
      dataTable: {
        sort: {
          field: this.dataTable.sort.field,
          type: this.dataTable.sort.type
        },
        currentPage: this.dataTable.currentPage,
        perPage: this.dataTable.perPage
      }
    })
  },
  watch: {
    'filter.key': function (val) {
      this.debouncedInput()
    },
    'dataTable.currentPage': function (val) {
      this.refreshData()
    },
    'dataTable.perPage': function (val) {
      this.refreshData()
    },
    'filter.status': function (val) {
      this.refreshData()
    },
    'filter.code': function (val) {
      this.refreshData()
    }
  }
}
</script>
<style scoped>
  table button {
    border-radius: 4px;
  }
  .table thead th:nth-child(2){
    width: 100px;
  }
  .table thead th:nth-child(3){
    width: 100px;
  }
  .table thead th:nth-child(4){
    width: 115px;
  }
  .table thead th:nth-child(5){
    width: 150px;
  }
  .table thead th:nth-child(6){
    width: 110px;
  }
  .table thead th:nth-child(8){
    width: 125px;
  }
  .table thead th:nth-child(9){
    width: 125px;
  }
  .table thead th:nth-child(10){
    width: 110px;
  }
  .table thead th:nth-child(1){
    width: 50px;
  }
  .table thead th:last-child{
    width: 290px;
  }
  .qr-code-img {
    padding: 15px 15px 15px 15px;
  }
  .qr-code-text {
    padding-top: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/views/admin/outlets/List.vue